export default ({
  cartRepository,
  maps,
  auth
}) => {
  return async (payload) => {
    const {
      onSuccess,
      onError,
      data,
      actions,
      dispatch
    } = payload

    try {
      const cart = await cartRepository.fetchCart({
        data,
        actions,
        maps,
        dispatch,
        auth: auth()
      })

      onSuccess({ cart})
    } catch(e) {
      console.log(e)

      onError()
    }
  }
}
